import { Component, OnInit } from '@angular/core';
import { verifyAccounts } from '../../models/request/shareReq';
import { verifyAccountResponse } from '../../models/response/shareRes';


@Component({
  selector: 'app-shared',
  templateUrl: './shared.component.html',
  styleUrls: ['./shared.component.css']
})
export class SharedComponent implements OnInit {
  accountverification= new verifyAccounts;
  verifiedAccountResponse = new verifyAccountResponse;

  constructor() { }

  ngOnInit() {
  }

  

}
